import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '@core';
import { RestClientService } from '@core/service/rest-client.service';

@Component({
  selector: 'app-marquee',
  imports: [FormsModule,CommonModule],
  templateUrl: './marquee.component.html',
  styleUrl: './marquee.component.scss'
})
export class MarqueeComponent {
   message: string = '';
  animationDuration: number = 10;
  isPaused: boolean = false;
  isLoading: boolean = false;

  @ViewChild('container') container!: ElementRef;
  @ViewChild('content') content!: ElementRef;

  private refreshInterval?: any;
  private resizeObserver?: ResizeObserver;
  private baseSpeed: number = 50; // pixels per second
  user: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private authService:AuthService,
    private restClient:RestClientService
  ) {
    this.user=this.authService.currentUser
  }

  ngOnInit() {
    // this.getBroadcastMessages();
    this.setupAutoRefresh();
  }

  ngAfterViewInit() {
    this.setupResizeObserver();
    this.setupHoverEvents();

     setTimeout(() => {
    this.updateMarqueeSpeed();
  });
  }
  

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  getBroadcastMessages() {
    this.isLoading = true;
    this.message = '';
    
    let request = {
      index: 0,
      size: 1000,
      data: {
        // prestataire_id: this.user?.prestataire_id,
      },
    };

    this.restClient.post('messageBroadcast/getMassageByPrestataire', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          if (res.items.length) {
            const messages = res.items.map((it: any) => it.libelle + ': ' + it.message);
            this.message = messages.join(' | '); // separator between messages
            // Wait for the next Angular change detection cycle
            this.scheduleMarqueeUpdate();
          }
          console.log('Broadcast messages loaded:', this.message);
        } else {
          this.message = '';
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Error loading broadcast messages:', error);
        this.message = '';
      }
    );
  }

  private scheduleMarqueeUpdate() {
    // Use multiple strategies to ensure elements are ready
    setTimeout(() => {
      if (this.updateMarqueeSpeed()) {
        return; // Success, no need to try again
      }
      
      // If first attempt failed, try again with longer delay
      setTimeout(() => {
        if (this.updateMarqueeSpeed()) {
          return;
        }
        
        // Final attempt with change detection
        this.cdr.detectChanges();
        setTimeout(() => {
          this.updateMarqueeSpeed();
        }, 100);
      }, 200);
    }, 0);
  }

  // updateMarqueeSpeed(): boolean {
  //   // Return boolean to indicate success/failure
  //   if (!this.container?.nativeElement || !this.content?.nativeElement || !this.message) {
  //     console.log('Marquee elements not ready yet');
  //     return false;
  //   }

  //   try {
  //     const containerWidth = this.container.nativeElement.offsetWidth;
  //     const contentWidth = this.content.nativeElement.scrollWidth;
      
  //     if (containerWidth === 0 || contentWidth === 0) {
  //       console.log('Elements not fully rendered yet');
  //       return false;
  //     }
      
  //     if (contentWidth <= containerWidth) {
  //       // If content fits in container, no need for scrolling
  //       this.animationDuration = 0;
  //       return true;
  //     }

  //     // Calculate duration based on content length and desired reading speed
  //     const totalDistance = containerWidth + contentWidth;
      
  //     // Adjust speed based on text length for readability
  //     const readabilityFactor = this.calculateReadabilityFactor(this.message.length);
  //     const adjustedSpeed = this.baseSpeed * readabilityFactor;
      
  //     this.animationDuration = totalDistance / adjustedSpeed;
      
  //     // Ensure minimum and maximum durations
  //     this.animationDuration = Math.max(5, Math.min(120, this.animationDuration));
      
  //     console.log(`Marquee speed: ${this.animationDuration}s for ${this.message.length} characters`);
  //     return true;
  //   } catch (error) {
  //     console.error('Error updating marquee speed:', error);
  //     return false;
  //   }
  // }

  private updateMarqueeSpeed(): boolean {
  if (!this.container?.nativeElement || !this.content?.nativeElement || !this.message) {
    return false;
  }

  requestAnimationFrame(() => {
    const containerWidth = this.container.nativeElement.offsetWidth;
    const contentWidth = this.content.nativeElement.scrollWidth;
    
    if (contentWidth <= containerWidth) {
      this.animationDuration = 0;
      return;
    }

    const totalDistance = containerWidth + contentWidth;
    const readabilityFactor = this.calculateReadabilityFactor(this.message.length);
    const adjustedSpeed = this.baseSpeed * readabilityFactor;
    
    this.animationDuration = Math.max(5, Math.min(120, totalDistance / adjustedSpeed));
    this.cdr.detectChanges();
  });
  
  return true;
}

  private calculateReadabilityFactor(textLength: number): number {
    // Slower speed for longer texts to improve readability
    if (textLength > 1000) return 0.2;
    if (textLength > 500) return 0.3;
    if (textLength > 300) return 0.5;
    if (textLength > 150) return 0.7;
    return 1.0;
  }

  togglePause() {
    this.isPaused = !this.isPaused;
  }

  adjustSpeed(direction: 'faster' | 'slower') {
    const factor = direction === 'faster' ? 0.7 : 1.4;
    this.animationDuration = Math.max(2, Math.min(180, this.animationDuration * factor));
  }

  refreshMessages() {
    // this.getBroadcastMessages();
  }

  private setupAutoRefresh() {
    // Auto-refresh every 5 minutes
    this.refreshInterval = setInterval(() => {
      // this.getBroadcastMessages();
    }, 5 * 60 * 1000);
  }

  private setupResizeObserver() {
    if (typeof ResizeObserver !== 'undefined' && this.container?.nativeElement) {
      this.resizeObserver = new ResizeObserver(() => {
        this.scheduleMarqueeUpdate();
      });
      this.resizeObserver.observe(this.container.nativeElement);
    }
  }

  private setupHoverEvents() {
    if (this.container?.nativeElement) {
      const container = this.container.nativeElement;
      container.addEventListener('mouseenter', () => {
        this.isPaused = true;
      });
      container.addEventListener('mouseleave', () => {
        this.isPaused = false;
      });
    }
  }
}
